import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import Steps from "../steps/Steps";
import * as GrIcons from "react-icons/gr";
import { useWizard } from "react-use-wizard";
import Select from "react-select";
import { toast } from "react-toastify";
import { stepActions } from "../../store/Steps";
import { useDispatch, useSelector } from "react-redux";
import { variants } from "../../shared/variants";
import { profileActions } from "../../store/UserProfileData";
import { useMixpanel } from "react-mixpanel-browser";
import { useTranslation } from "react-i18next";

export interface IRelationship {
  nokRelationship: string;
}

function BeneficiaryDetails({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const profileSelector = useSelector((state: any) => state?.profile?.profile);

  const mixpanel = useMixpanel()

  const { previousStep, nextStep, goToStep } = useWizard();
  const dispatch = useDispatch();
  const [beneficiaryInfo, setBeneficiaryInfo] = useState({
    nokName: profileSelector?.nokName ? profileSelector?.nokName : "",
    nokRelationship: profileSelector?.nokRelationship
      ? profileSelector?.nokRelationship
      : "",
    nokPhoneNo: profileSelector?.nokPhoneNo ? profileSelector?.nokPhoneNo : "",
    nokLocation: profileSelector?.nokLocation
      ? profileSelector?.nokLocation
      : "",
    nokPostalAddress: profileSelector?.nokPostalAddress
      ? profileSelector?.nokName
      : "",
    nokPostalCode: profileSelector?.nokPostalCode
      ? profileSelector?.nokPostalCode
      : "",
  });

  const defaultNokRelationship = {
    value: profileSelector?.nokRelationship
      ? profileSelector?.nokRelationship
      : "",
    label: profileSelector?.nokRelationship
      ? profileSelector?.nokRelationship
      : "",
  };
  const [selectedOption, setSelectedOption] = useState<IRelationship>();
  const [showRelationship, setOnshowRelationship] = useState<boolean>(false);

  const [notSurePostalDetails, setNotSurePostalDetails] =
    useState<boolean>(false);
  const [notSureLocationDetails, setNotSureLocationDetails] =
    useState<boolean>(false);

  const relationships = [
    { value: "mother", label: t("beneficiary.relationships.mother") },
    { value: "aunt", label: t("beneficiary.relationships.aunt") },
    { value: "brother", label: t("beneficiary.relationships.brother") },
    { value: "cousin", label: t("beneficiary.relationships.cousin") },
    { value: "grandfather", label: t("beneficiary.relationships.grandfather") },
    { value: "grandmother", label: t("beneficiary.relationships.grandmother") },
    { value: "niece", label: t("beneficiary.relationships.niece") },
    { value: "nephew", label: t("beneficiary.relationships.nephew") },
    { value: "sister", label: t("beneficiary.relationships.sister") },
    { value: "son", label: t("beneficiary.relationships.son") },
    { value: "spouse", label: t("beneficiary.relationships.spouse") },
    { value: "uncle", label: t("beneficiary.relationships.uncle") },
    { value: "daughter", label: t("beneficiary.relationships.daughter") },
    { value: "father", label: t("beneficiary.relationships.father") },
    { value: "other", label: t("beneficiary.relationships.other") },
  ];

  useEffect(() => {
    sessionStorage.setItem("details-screen", "Beneficiary-screen");
    setCurrentScreen("Beneficiary-screen");
  });

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setBeneficiaryInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (selectedOption: any) => {
    // if (selectedOption.value == "other") {
    //   setOnshowRelationship(true);
    // } else {
    //   setOnshowRelationship(false);
    // }
    setSelectedOption(selectedOption);
    setBeneficiaryInfo((previousState: any) => ({
      ...previousState,
      nokRelationship: selectedOption.value,
    }));
  };

  const saveDetails = () => {
    if (!beneficiaryInfo.nokName) {
      toast.warning(t("beneficiary.enterName"));
      document.getElementById("nokName")?.focus();
      return;
    }

    let pattern =
      /^(?=.{3,})([A-Za-z']{3,}\s+){1,2}([A-Za-z']+\s+)*[A-Za-z']+\s*$/;
    if (!pattern.test(beneficiaryInfo.nokName)) {
      toast.warning(t("beneficiary.enterTwoNames"));
      document.getElementById("nokName")?.focus();
      return;
    }
    // if (!selectedOption) {
    //   toast.warning("Enter Beneficiary's Relationship!");
    //   return;
    // }
    const onValidatePhoneNumber = (phoneNumber: any) => {
      const regex = /^(\+254|0)[1-9]\d{8}$/.test(phoneNumber);
      return regex;
    };
    if (!onValidatePhoneNumber(beneficiaryInfo.nokPhoneNo)) {
      toast.warning(t("beneficiary.enterValidPhone"));
      document.getElementById("nokPhoneNo")?.focus();
      return;
    }
    if (!notSurePostalDetails) {
      if (!beneficiaryInfo.nokPostalAddress) {
        toast.warning(t("beneficiary.enterPostalAddress"));
        document.getElementById("nokPostalAddress")?.focus();
        return;
      }
      if (!beneficiaryInfo.nokPostalCode) {
        toast.warning(t("beneficiary.enterPostalCode"));
        document.getElementById("nokPostalCode")?.focus();
        return;
      }
    }
    if (!notSureLocationDetails) {
      if (!beneficiaryInfo.nokLocation) {
        toast.warning(t("beneficiary.enterLocation"));
        document.getElementById("nokLocation")?.focus();
        return;
      }
    }
    sessionStorage.setItem("beneficiaryInfo", JSON.stringify(beneficiaryInfo));
    sessionStorage.removeItem("details-screen");
    if (dispatch(stepActions.onAddStep())) {
      nextStep();
      let userPrfile = {
        ...profileSelector,
        nokName: beneficiaryInfo.nokName,
        nokRelationship: beneficiaryInfo.nokRelationship,
        nokPhoneNo: beneficiaryInfo.nokPhoneNo,
        nokLocation: beneficiaryInfo.nokLocation,
        nokPostalAddress: beneficiaryInfo.nokPostalAddress,
        nokPostalCode: beneficiaryInfo.nokPostalCode,
      };
      dispatch(profileActions.setUserProfile(userPrfile));
    }
  };

  const goToThePreviousStep = () => {
    const screen = sessionStorage.getItem("travel_type")!;
    if (screen == "Group" || screen == "Family") {
      sessionStorage.setItem("details-screen", "Group-screen");
      setCurrentScreen("Group-screen");
    } else {
      if (dispatch(stepActions.onRemoveStep())) {
        sessionStorage.removeItem("details-screen");
        sessionStorage.setItem("docs-current-screen", "insurer-docs");
        previousStep();
      }
    }
  };
  const setNokPostalStatus = () => {
    if (notSurePostalDetails) {
      setNotSurePostalDetails(false);
    } else {
      setNotSurePostalDetails(true);
    }
  };
  const setNokLocationStatus = () => {
    if (notSureLocationDetails) {
      setNotSureLocationDetails(false);
    } else {
      setNotSureLocationDetails(true);
    }
  };

  useEffect(()=> {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Beneficiary-details",
      });
    }
  }, [mixpanel])

  return (
    <motion.div
      variants={variants}
      initial="enter"
      animate="center"
      exit={{ opacity: 0 }}
    >
      <Steps name="beneficiary" />
      <div className="container">
        <div className="ky-inputs-container ky-inputs-container-beneficiary">
          <div className="reg-title text-left">
            {t("beneficiary.provideDetailsHeader")}{" "}
            <span className="span-title">{t("beneficiary.beneficiaryDetails")}</span>
          </div>
          <br />
          <div className="row d-flex justify-content-between-align-items-center">
            <div className="col-md-4">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="nokName">
                  {t("beneficiary.nameLabel")}
                </label>
                <br />
                <input
                  id="nokName"
                  name="nokName"
                  type="text"
                  onChange={handleInputChange}
                  value={beneficiaryInfo.nokName}
                  placeholder={t("beneficiary.typeHere")}
                ></input>
              </motion.div>
            </div>
            </div>
            <div className="col-md-4">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label
                  className="text-left-label mb-2"
                  htmlFor="nokRelationship"
                >
                  {t("beneficiary.relationshipLabel")}{" "}
                </label>
                <br />
                <Select
                  options={relationships}
                  onChange={handleChange}
                  id={"nokRelationship"}
                  defaultValue={defaultNokRelationship}
                  className={"nokRelationship"}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: "#F6F8FB",
                      border: state.isFocused ? "none" : "#F6F8FB",
                    }),
                    placeholder: (baseStyles, state) => ({
                      ...baseStyles,
                    }),
                    input: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "315px",
                      height: "47px",
                    }),
                    dropdownIndicator: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "#00000",
                      fontWeight: "bold",
                    }),
                    container: (baseStyles, state) => ({
                      ...baseStyles,
                      border: "none",
                      marginRight: "1rem",
                    }),
                  }}
                />{" "}
                {showRelationship && (
                  <div className="ky-input-wrapper ky-input-wrapper-other-relationship">
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                      className="ky-input-container mt-1"
                    >
                      <input
                        id="nokRelationship"
                        name="nokRelationship"
                        type="text"
                        className="other-relationship"
                        onChange={handleInputChange}
                        value={beneficiaryInfo.nokRelationship}
                        placeholder={t("beneficiary.enterRelationship")}
                      ></input>
                    </motion.div>
                  </div>
                )}
              </motion.div>
            </div>
            </div>
            <div className="col-md-4">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="nokPhoneNo">
                  {t("beneficiary.phoneLabel")}{" "}
                </label>
                <br />
                <input
                  id="nokPhoneNo"
                  name="nokPhoneNo"
                  type="text"
                  onChange={handleInputChange}
                  value={beneficiaryInfo.nokPhoneNo}
                  placeholder={t("beneficiary.phonePlaceholder")}
                ></input>
              </motion.div>
            </div>
            </div>
          </div>

          <div className="ky-inputs-inner-container w-100">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("beneficiary.postalLabel")}{" "}
                </label>
                <br />
                {!notSurePostalDetails && (
                  <div className="postal-area-container nokDetails">
                    <input
                      id="nokPostalAddress"
                      name="nokPostalAddress"
                      type="text"
                      onChange={handleInputChange}
                      value={beneficiaryInfo.nokPostalAddress}
                      placeholder={t("beneficiary.poBox")}
                    ></input>

                    <input
                      id="nokPostalCode"
                      name="nokPostalCode"
                      type="text"
                      onChange={handleInputChange}
                      value={beneficiaryInfo.nokPostalCode}
                      placeholder={t("beneficiary.postalCode")}
                    ></input>
                  </div>
                )}
                <div
                  className={
                    notSurePostalDetails
                      ? "not-sure mt-2 active-postal-nok"
                      : "not-sure mt-2"
                  }
                  onClick={() => setNokPostalStatus()}
                >
                  <p>{t("beneficiary.notSure")}</p>
                </div>
              </motion.div>
            </div>

            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="nokLocation">
                  {t("beneficiary.locationLabel")}
                </label>
                <br />
                {!notSureLocationDetails && (
                  <div className="location-area-container">
                    <input
                      id="nokLocation"
                      name="nokLocation"
                      type="text"
                      onChange={handleInputChange}
                      value={beneficiaryInfo.nokLocation}
                      placeholder={t("beneficiary.typeLocation")}
                    ></input>
                  </div>
                )}
                <div
                  className={
                    notSureLocationDetails
                      ? "not-sure mt-2 active-location-nok"
                      : "not-sure mt-2"
                  }
                  onClick={() => setNokLocationStatus()}
                >
                  <p>{t("beneficiary.notSure")}</p>
                </div>
              </motion.div>
            </div>
          </div>

          <div className="ky-inputs-inner-container w-100">
            <div className="ky-input-wrapper"></div>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5">
            <div className="previous">
              <span onClick={goToThePreviousStep}>
                <span className="GrIcon me-2">
                  <GrIcons.GrFormPreviousLink />
                </span>{" "}
                <span className="previous">{t("beneficiary.previous")}</span>
              </span>
            </div>
            <div onClick={() => saveDetails()}>
              <button className="next-btn">{t("beneficiary.proceed")}</button>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </motion.div>
  );
}

export default BeneficiaryDetails;
